module.exports = __webpack_public_path__ + "img/BY.9662b32d.png";